/////////////////////////////////////////////////
// Standard scroll will toggle hide/show all element after
// selected element with class .comp-toggle-next
//
// https://github.com/mymuesli/mymuesli-web/wiki/jQuery-Solutions
//
////////////////////////////////////////////////////////////

class ToggleNext {
    constructor(element) {
        /**
         * our object
         * @type {object}
         */
        this.element = element;
    }

    run() {
        var hide = this.hide;
        var scroll = this.scroll;
        var element = this.element;

        if (this.element.hasClass('active')) {
            this.element.removeClass('active').next().slideUp();
        } else {
            if (!element.hasClass('unique')) {
                $('.comp-toggle-next:visible').removeClass('active').next().slideUp(function(){
                    $(this).css('display', ''); // remove inline property after slideUp
                });
            }
            this.element.addClass('active').next().slideDown(function() {
                if (scroll) {
                    element.scrollIntoView();
                }
            });
        }

        if (hide) {
            this.element.addClass('hidden');
        }
    }
}

$(function(){
    // TOGGLE NEXT
    $('.comp-toggle-next.active').next().css('display', 'block');
    $(this).on('click', '.comp-toggle-next:visible', function(e){
        e.preventDefault();
        const toggleNext = new ToggleNext($(this));
        toggleNext.scroll = toggleNext.element.is('[js-scroll]');
        toggleNext.hide = toggleNext.element.is('[js-hide]');
        toggleNext.run();
    });
});